module.exports = __webpack_public_path__ + "img/奖章4级@2x.f06cd6f1.png";